














import Vue from 'vue';
import BlogEntry from './blogsection/BlogEntry.vue';
import { IBlogEntry, IBlogSection } from '../../../common/interfaces/frontpage.interface';
import FrontpageHelper from '../../../helpers/page-specific/FrontpageHelper';

export default Vue.extend({
  name: `BlogSection`,
  components: { BlogEntry },
  data(): IBlogSection {
    return {
      blogEntriesVisible: false,
      firstBlogEntry: null,
    };
  },
  props: {
    blogEntries: {
      required: true,
      type: Array as () => IBlogEntry[],
    },
  },
  mounted(): void {
    this.firstBlogEntry = (this.$refs.firstBlogEntry as Vue).$el as HTMLElement;
    document.addEventListener(`scroll`, this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy(): void {
    document.removeEventListener(`scroll`, this.handleScroll);
  },
  methods: {
    handleScroll(): void {
      if(!this.blogEntriesVisible && this.firstBlogEntry) {
        this.blogEntriesVisible = FrontpageHelper.isElemVisible(this.firstBlogEntry);
      }
    },
  },
});
